import {
  IInfrastructurePinForMapSchema,
  EType,
} from '../repositories/favorites/entities/user_folder/InfrastructurePinForMapSchema';
import { IOfferPinSchema } from '../repositories/favorites/entities/user_folder/OfferPinSchema';

interface IMapState {
  isOpen: boolean;
  data: IMapData;
  activePin?: number;
}

interface IMapData {
  infrastructurePins: IInfrastructurePinForMapSchema[];
  offerPins: IOfferPinSchema[];
  status: EGetMapDataStatus;
}

enum EGetMapDataStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export { EType, IMapState, IMapData, EGetMapDataStatus };

export type TOfferPin = IOfferPinSchema;
export type TInfrastructurePin = IInfrastructurePinForMapSchema;
